const require_link = require("../types/value/link.cjs");
//#region src/helpers/documentToLinkField.ts
/**
* Converts a document into a link field, this is useful when crawling the API for document links
*
* @typeParam TDocument - Specific interface of the provided document
* @param prismicDocument - A document coming from Prismic
* @returns The equivalent link field to use with `asLink()`
* @internal
*/
const documentToLinkField = (prismicDocument) => {
	return {
		link_type: require_link.LinkType.Document,
		id: prismicDocument.id,
		uid: prismicDocument.uid || void 0,
		type: prismicDocument.type,
		tags: prismicDocument.tags,
		lang: prismicDocument.lang,
		url: prismicDocument.url == null ? void 0 : prismicDocument.url,
		slug: prismicDocument.slugs?.[0],
		...prismicDocument.data && Object.keys(prismicDocument.data).length > 0 ? { data: prismicDocument.data } : {}
	};
};
//#endregion
exports.documentToLinkField = documentToLinkField;

//# sourceMappingURL=documentToLinkField.cjs.map